import * as React from 'react'

const IconCopy = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g fill='#00B2E3' fillRule='evenodd'>
      <path d='M10 20h8V8h-8v12zm9.5 3h-11A1.5 1.5 0 0 1 7 21.5v-15A1.5 1.5 0 0 1 8.5 5h11A1.5 1.5 0 0 1 21 6.5v15a1.5 1.5 0 0 1-1.5 1.5z' />
      <path d='M4.5 19A1.5 1.5 0 0 1 3 17.5v-15A1.5 1.5 0 0 1 4.5 1h11a1.5 1.5 0 1 1 0 3H6v13.5A1.5 1.5 0 0 1 4.5 19' />
    </g>
  </svg>
)

export default IconCopy
